import { AttributeType, LevelType, SpaceType } from 'data/types';
import { getItem } from 'utils/data';

export const AUTO_LAYOUT_SPACE_ATTRIBUTE_CODE = 'auto_layout_space';

function autoLayoutAttributeValue(space: SpaceType): unknown {
  return space.attributes.find(
    (attribute) => attribute.code === AUTO_LAYOUT_SPACE_ATTRIBUTE_CODE
  )?.value;
}

export function spaceHasAutoLayoutAttribute(space: SpaceType): boolean {
  const value = autoLayoutAttributeValue(space);
  return value === true || value === 'true' || value === 'Yes';
}

export function markAutoLayoutSpace(
  space: SpaceType,
  catalogAttributes: AttributeType[]
): SpaceType {
  if (spaceHasAutoLayoutAttribute(space)) {
    return space;
  }
  const catalog = catalogAttributes.find(
    (attribute) => attribute.code === AUTO_LAYOUT_SPACE_ATTRIBUTE_CODE
  );
  if (!catalog) {
    return space;
  }
  return {
    ...space,
    attributes: [...space.attributes, { ...catalog, value: true }]
  };
}

export function isAutoLayoutSpace(
  space: SpaceType,
  level: LevelType,
  autoLayoutSpaceIds: ReadonlySet<string> | readonly string[]
): boolean {
  const ids = Array.isArray(autoLayoutSpaceIds)
    ? autoLayoutSpaceIds
    : [...autoLayoutSpaceIds];
  if (ids.includes(space.uniqueId)) {
    return true;
  }
  if (spaceHasAutoLayoutAttribute(space)) {
    return true;
  }
  if (space.label !== level.label) {
    return false;
  }
  const itemCode = getItem(space.itemId)?.code;
  return itemCode === 'custom' || itemCode === 'open_space';
}

export function collectLevelAutoLayoutSpaces(
  level: LevelType,
  autoLayoutSpaceIds: ReadonlySet<string> | readonly string[]
): SpaceType[] {
  return level.sections.flatMap((section) =>
    section.spaces.filter((space) =>
      isAutoLayoutSpace(space, level, autoLayoutSpaceIds)
    )
  );
}

export function collectLevelUserPlacedSpaces(
  level: LevelType,
  autoLayoutSpaceIds: ReadonlySet<string> | readonly string[]
): SpaceType[] {
  return level.sections.flatMap((section) =>
    section.spaces.filter(
      (space) => !isAutoLayoutSpace(space, level, autoLayoutSpaceIds)
    )
  );
}
